import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { CityService } from '../../../../../app/shared/API-Service/services/city.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { BaseComponent } from 'src/app/shared/components/base/base.component';

  

@Component({
  selector: 'app-view-city',
  templateUrl: './view-city.component.html',
  styleUrls: ['./view-city.component.css']
})
export class ViewCityComponent extends BaseComponent implements OnInit {
  cities:object [] = [];
 
  constructor(private _CityService:CityService, private _Router:Router) { 
    super()
  }

  ngOnInit(): void {
    this.getcities();
  }
   pageChanged(event: any){
    this.pageNumber = event.page;// -1 * pageSize;
    this.pager.skipCount = (this.pageNumber - 1) * this.pager.maxResultCount;
   this.getcities();
  }
  getcities(){
    this._CityService.GetCityPaged(this.pager).subscribe((res) => {
      this.cities = res.data.items
      this.totalCount=res.data.totalCount
    
    },(err)=>{
    },() =>{
    });
  }

  update(data){
    this._CityService.Data.next(data);
    this._Router.navigate(['/content/admin/InsertCity']);
    }
    
    delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this._CityService.DeleteCity(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
         this.getcities();
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'خطأ',
              text:err.error.message    
            })
          },() => {
          })
        }
      }) 
    }
}
